module.exports = __webpack_public_path__ + "img/05-Android.0bd44869.png";